module.exports = __webpack_public_path__ + "img/icon-jpg.865b33ac.svg";